import { render, staticRenderFns } from "./PMCharts.vue?vue&type=template&id=45d6aac3&"
import script from "./PMCharts.vue?vue&type=script&lang=ts&"
export * from "./PMCharts.vue?vue&type=script&lang=ts&"
import style0 from "./PMCharts.vue?vue&type=style&index=0&id=45d6aac3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports